<template>
	<table class="list_tbl" v-columns-resizable>
		<thead>
			<tr>
				<!-- #3406 : Restriction Only 보기는 조회 전용이라 행 선택(일괄 변경·명세서)이 없다. -->
				<th v-if="!restriction_only" style="width: 1%">
					<input type="checkbox" v-model="selectedAll" @click="selectAll" />
				</th>
				<template v-for="(v, i) in showColumns">
					<th v-if="v[i_show]" :key="i" :style="{ width: v[i_width] }">
						<span class="pointer" @click="sort(v[i_key])">{{ v[i_name] }}</span>
						<span v-if="sort_key === v[i_key]">{{ sortSign }}</span>
					</th>
				</template>
			</tr>
		</thead>
		<tbody>
			<tr v-for="partner in partners" v-bind:key="partner.code">
				<td v-if="!restriction_only" class="al_center">
					<input type="checkbox" v-model="partner.selected" />
				</td>
				<template v-for="(v, index) in showColumns">
					<td v-if="v[i_show]" :class="v[i_class]" :key="partner.code + index">
						<router-link v-if="v[i_key] === 'code'" tag="a" :to="detailLink(partner[v[i_key]])">{{ partner[v[i_key]] }}</router-link>

						<span v-else-if="v[i_key] === 'memo'" @click="memo(partner)" :class="partner.memo ? 'red_bold' : ''">Memo</span>

						<span v-else-if="v[i_key] === 'blocked' && partner.blocked" :title="partner.block_reason" class="red_bold">&#10004;</span>

						<template v-else-if="currencyList.includes(v[i_key])">
							<template v-if="!['ytd', 'last_invoice_amount'].includes(v[i_key])">
								<span :style="partner[v[i_key]] > 0 ? 'color:red' : partner[v[i_key]] < 0 ? 'color:blue' : 'color:black'">
									<span v-if="['balance', 'post_check_amount'].includes(v[i_key])" class="pointer" @click="$emit('arHistory', partner.code, partner.name)">
										{{ partner[v[i_key]] | toCurrency }}
									</span>
									<span v-else>
										{{ partner[v[i_key]] | toCurrency }}
									</span>
								</span>
							</template>
							<template v-else>
								<span>{{ partner[v[i_key]] | toCurrency }}</span>
							</template>
						</template>
						<span v-else-if="partner[v[i_key]]" :title="partner[v[i_key]]">{{ partner[v[i_key]] }}</span>
					</td>
				</template>
			</tr>
		</tbody>
	</table>
</template>
<script>
import { getColumns } from '@/api/partner/partnerTable';

export default {
	name: 'partnerTable',
	props: {
		company_id: {},
		partners: {},
		sort_direction: {
			type: String,
		},
		sort_key: {
			type: String,
		},
		// #3406 : Restriction Only 보기(지정 State 조회 전용). 행 선택을 숨기고 상세도 같은 보기로 연다.
		restriction_only: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			selectedAll: false,
			i_key: 0,
			i_name: 1,
			i_show: 2,
			i_width: 3,
			i_class: 4,
			i_order: 5,
			currencyList: ['ytd', 'balance', 'post_check_amount', 'store_credit_amount', 'last_invoice_amount'],
		};
	},
	computed: {
		showColumns() {
			return getColumns(this.routerName, this.company_id);
		},
		routerName() {
			return this.$router.history.current.name;
		},
		sortSign() {
			return this.sort_direction === 'ASC' ? '▲' : '▼';
		},
	},
	methods: {
		// #3406 : 기본은 종전 링크 그대로다. Restriction Only 보기에서만 상세 URL 에 플래그를 싣는다.
		detailLink(code) {
			const query = { code: code };
			if (this.restriction_only) query.restriction_only = 'true';
			return { name: 'partnerDetail', query: query, params: { mode: 'detail' } };
		},
		sort(key) {
			this.$emit('sort', key);
		},
		selectAll() {
			this.partners.forEach(partner => {
				partner.selected = !this.selectedAll;
			});
		},
		memo(partner) {
			this.$emit('memo', partner);
		},
	},
};
</script>
